import { useEffect } from "react";

const getDeviceInfo = () => {
    return navigator.userAgent;
};

const getPublicIP = async () => {
    try {
        const response = await fetch("https://api64.ipify.org?format=json");
        const data = await response.json();
        return data.ip;
    } catch (error) {
        console.error("Failed to get public IP:", error);
        return "Unknown IP";
    }
};

const DeviceInfo = ({ setDeviceId, setUserIp }) => {
    useEffect(() => {
        // Fetch Device Info
        const deviceInfo = getDeviceInfo();
        setDeviceId(deviceInfo);
        localStorage.setItem("deviceId", deviceInfo); // Save deviceId to localStorage

        // Fetch Public IP
        getPublicIP().then(ip => {
            setUserIp(ip);
            localStorage.setItem("userIp", ip); // Save userIp to localStorage
        });
    }, [setDeviceId, setUserIp]);

    return null; // No UI, just fetching data
};

export default DeviceInfo;